module.exports = __webpack_public_path__ + "static/media/interviewQuestions1.31327804.png";